import { Component, Host, h, Prop } from '@stencil/core';

/**
 * @slot - Designed to replace the standard step content.
 */
@Component({
  tag: 'sy-step',
  styleUrl: './scss/index.scss',
  shadow: true,
})
export class Step {
  /**
   * Step state
   */
  @Prop({ reflect: true }) state: 'done' | 'active' | 'error' | 'to-do' = 'to-do';

  /**
   * Step label
   */
  @Prop() label: string;

  private getIconState() {
    if (this.state === 'to-do') {
      return <sy-icon name="check-circle-1" size="24"></sy-icon>;
    }

    if (this.state === 'active') {
      return <sy-icon name="check-circle-1" size="24" color="primary"></sy-icon>;
    }

    if (this.state === 'done') {
      return <sy-icon name="check-circle-1" size="24" color="success"></sy-icon>;
    }

    if (this.state === 'error') {
      return <sy-icon name="alert-circle" size="24" color="error"></sy-icon>;
    }
  }

  render() {
    return (
      <Host>
        <slot>
          {this.getIconState()} <span>{this.label}</span>
        </slot>
      </Host>
    );
  }
}
